import words from 'lodash/words';

import { PlaceAutocompleteOnSelectArgs } from '../PlacesAutocomplete.types';

interface NormalizedAddressComponent {
  longName: string;
  shortName: string;
  types: string[];
}

const findComponent = (
  components: NormalizedAddressComponent[],
  type: string,
): NormalizedAddressComponent | undefined => {
  return components.find((component) =>
    component.types.some((componentType) => componentType === type),
  );
};

export const adaptAddressComponentsToResponse = ({
  components,
  address,
}: {
  components: NormalizedAddressComponent[];
  address: string;
}): PlaceAutocompleteOnSelectArgs => {
  const country = findComponent(components, 'country');
  const cityAddressComponent =
    findComponent(components, 'locality') ||
    findComponent(components, 'postal_town') ||
    findComponent(components, 'sublocality');

  let streetNumber = findComponent(components, 'street_number')?.longName;

  if (!streetNumber) {
    streetNumber = words(address, /\d+/)?.[0];
  }

  return {
    countryCode: country?.shortName,
    streetNumber,
    street: findComponent(components, 'route')?.longName,
    city: cityAddressComponent?.longName,
    postalCode: findComponent(components, 'postal_code')?.longName,
  };
};
